import { ChatAssistantContainer } from "./container";
import { PageFrame } from "../../components/page_frame";

export const ChatAssistantPage = () => {
  return (
    <PageFrame>
      <ChatAssistantContainer />
    </PageFrame>
  );
};
